<template>
  <v-card
    :class="{'active': isActive, 'defaultBg': !isActive && isDefault, 'customBg': !isActive && !isDefault}"
    :height="210"
    class="pa-2 synthesis-card-border synthesis-list-card"
    flat
    @click="onCardClick"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="synthesis-inter-text text-size-12 synthesis-ui-grey-01--text pb-0">
          {{ title }}
        </div>
        <v-list-item-title class="synthesis-text text-size-32 synthesis-brand-dark-blue--text pt-0 pb-0">
          <span
            v-if="titlePrefix"
            class="pt-md-6 pt-3 pr-2 text-size-20 font-weight-medium synthesis-brand-dark-blue--text"
          >
            {{ titlePrefix }}
            <infotip
              v-if="titlePrefixTooltip"
              icon-style="margin-top: -26px"
            >{{ titlePrefixTooltip }}
            </infotip>
          </span>
          <span
            v-if="baseCurrencySymbol"
            class="pt-4 pr-1 synthesis-text text-size-14 synthesis-brand-dark-blue--text"
            v-text="baseCurrencySymbol"
          />{{ titleValue }}
        </v-list-item-title>

        <div>
          <span class="subtitle-text">
            {{ subtitle }}
          </span>
        </div>
      </v-list-item-content>

      <v-list-item-avatar
        v-if="pieValues && pieValues.length"
        :size="120"
        class="ma-2 mr-0"
        tile
      >
        <base-e-chart-pie
          :axis-y-tick-prefix="baseCurrencySymbol"
          :chart-data-options="pieValues"
          :chart-height="130"
          :tooltip-show="true"
          :tooltip-suffix="'%'"
          chart-animation-easing="elasticOut"
          tooltip-confine
        />
      </v-list-item-avatar>
    </v-list-item>

    <v-card-actions class="pa-4">
      <span class="synthesis-inter-text text-size-10 synthesis-ui-grey-01--text">{{ dateCreated }}</span>

      <v-spacer />

      <v-menu
        bottom
        offset-y
      >
        <template #activator="{on, attrs}">
          <v-btn
            color="grey"
            icon
            v-bind="attrs"
            v-on="on"
            @click.stop
          >
            <v-icon>
              mdi-dots-horizontal
            </v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0 ma-0">
          <v-list-item
            @click="onActiveClick"
          >
            <v-list-item-title class="text-size-14">
              {{ $t('Risks.Tab.Archive.Card.MenuItems.0.Title') }}
            </v-list-item-title>

            <v-list-item-action>
              <v-icon color="synthesis-ui-green-06">
                mdi-bookmark
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            v-if="!isDefault"
            @click="onDeleteClick"
          >
            <v-list-item-title class="text-size-14">
              {{ $t('Common.Button.Delete') }}
            </v-list-item-title>

            <v-list-item-action>
              <v-icon color="error">
                mdi-trash-can
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
  </v-card>
</template>

<script>

import BaseEChartPie from '@/theme/default/components/charts/echarts/BaseEChartPie'
import Infotip       from '@/theme/default/components/common/Infotip'

export default {
  name      : 'RiskArchiveItemCard',
  components: {
    Infotip,
    BaseEChartPie
  },
  props: {
    baseCurrencySymbol: {
      type   : String,
      default: ''
    },
    title: {
      type   : String,
      default: ''
    },
    titlePrefix: {
      type   : String,
      default: ''
    },
    titlePrefixTooltip: {
      type   : String,
      default: ''
    },
    titleValue: {
      type   : String,
      default: ''
    },
    dateCreated: {
      type   : String,
      default: ''
    },
    pieValues: {
      type   : Array,
      default: () => []
    },
    isDefault: {
      type   : Boolean,
      default: false
    },
    isActive: {
      type   : Boolean,
      default: false
    },
    subtitle: {
      type   : String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    onCardClick () {
      this.$emit('card-click')
    },
    onDeleteClick () {
      this.$emit('delete-click')
    },
    onActiveClick () {
      this.$emit('active-click')
    }
  }
}
</script>

<style scoped>

.subtitle-text {
  background-color:var(--v-synthesis-ui-grey-05-base);
  font-size: 10px;
  padding:1px;
  font-weight: 500;
  text-transform: uppercase;
  color:var(--v-synthesis-ui-grey-01-base);
}

.defaultBg {
  background: linear-gradient(to bottom, var(--v-synthesis-ui-blue-08-base), #FFFFFF);
}

.customBg {
  background: linear-gradient(to bottom, var(--v-synthesis-ui-red-08-base), #FFFFFF);
}

</style>
